import { render } from "./EmbargosGobernacionCargueMasivoComponent.vue?vue&type=template&id=790f859a"
import script from "./EmbargosGobernacionCargueMasivoComponent.vue?vue&type=script&lang=js"
export * from "./EmbargosGobernacionCargueMasivoComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__